import { Client, ClientType } from '@/types/app';
import { isAndroidByUserAgent, isMobile, isWebViewByUserAgent } from '@/utils/mobile/RNPlugins';
import { HeadlessDetector } from './detect';

/**
 * 클라이언트 정보를 감지하는 유틸리티 함수
 * user-web과 RNPlugins에서 공통으로 사용할 수 있도록 추출
 *
 * @param userAgent - 브라우저 User Agent 문자열
 * @returns Client 객체 (플랫폼 정보 포함)
 */
export const getClientInfo = (userAgent: string | string[] | undefined): Client => {
  const defaultClient = {
    clientType: ClientType.WEB,
    isWebView: false,
    isMobile: false,
    isIOS: false,
    isAndroid: false,
    isHeadlessBot: false,
  };

  if (typeof userAgent !== 'string') {
    return defaultClient;
  }

  if (HeadlessDetector.isHeadlessUser(userAgent)) {
    return {
      clientType: ClientType.WEB,
      isWebView: false,
      isMobile: false,
      isAndroid: false,
      isIOS: false,
      isHeadlessBot: true,
    };
  }

  if (isWebViewByUserAgent(userAgent)) {
    // 웹뷰
    return {
      clientType: ClientType.MOBILE_WEBVIEW,
      isWebView: true,
      isMobile: true,
      isIOS: !isAndroidByUserAgent(userAgent),
      isAndroid: isAndroidByUserAgent(userAgent),
      isHeadlessBot: false,
    };
  }

  if (isMobile(userAgent)) {
    // 모바일 웹
    return {
      clientType: ClientType.MOBILE_WEB,
      isWebView: false,
      isMobile: true,
      isIOS: !isAndroidByUserAgent(userAgent),
      isAndroid: isAndroidByUserAgent(userAgent),
      isHeadlessBot: false,
    };
  }

  // 웹
  return {
    clientType: ClientType.WEB,
    isWebView: false,
    isMobile: false,
    isIOS: false,
    isAndroid: false,
    isHeadlessBot: false,
  };
};

/**
 * Legacy alias for backward compatibility
 * @deprecated Use getClientInfo instead
 */
export const detectClient = getClientInfo;

export default getClientInfo;
